import React, { Component } from 'react';
import dataModel from '../../models/DataModel';
import anime from 'animejs';
import ImageTools from '../../helpers/ImageTools';
import WaitSpinner from '../../components/WaitSpinner';
import CheckBox from '../CheckBox';
import Input from '../Input';
import './CopyBuildPopout.scss';

const buildDescriptor = {
  build: {
    tasks: {},
  },
};

class CopyBuildPopout extends Component {

  constructor(props) {
    super(props);
    this.state = {
      build: props.build,
      buildName: props.build.name + ' (Copy)',
      selectedTasks: {},
      isAllChecked: false,
    };

    this.changeBuildInfo = this.changeBuildInfo.bind(this);
    this.closePopup = this.closePopup.bind(this);
    this.handleBuildCopy = this.handleBuildCopy.bind(this);
    this.collapsePopup = this.collapsePopup.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.checkToggled = this.checkToggled.bind(this);

  }

  componentDidUpdate(){
    const { build } = this.state;
    if (this.props.displayCopyPopout) {
      this.expandPopup();
    }
    if(typeof build.tasks[0] == 'number'){
      dataModel.buildsDAO.getBuild(build.id, { recordDescriptor: buildDescriptor }, build => {
        this.setState({ build });
      })
        .then(build => {
          this.setState({ build });
        });
    }
  }

  expandPopup() {
    const { build } = this.state;
    const height =  !build.tasks.length ? 160 : 330;
    return anime({
      targets: this.copyBuildPopout,
      height: height,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup() {
    return anime({
      targets: this.copyBuildPopout,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 200,
      complete: () => {
        this.closePopup();
      },
    });
  }

  changeBuildInfo(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  closePopup() {
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  handleBuildCopy(e) {
    e.stopPropagation();
    const changedName = { 'name': this.state.buildName };
    const selectedTasksArray = Object.values(this.state.selectedTasks);
    dataModel.buildsDAO.copyBuild(this.state.build, changedName, selectedTasksArray).then(result => {
      if (result && result.error) {
        dataModel.displayInfoErrorMessage(result.error.response.data.message || 'An error occurred while copying the build.');
      } else {
        this.collapsePopup();
      }
    }).catch(err => {      
      dataModel.displayInfoErrorMessage(err || 'An unexpected error occurred.');
    });
  }

  getIconForCSType(completionStep) {
    return ImageTools.getGreyedCSIcon(completionStep, 'grey-outline');
  }

  toggleAll(){
    const value = this.state.isAllChecked;
    if(!value){
      const { build } = this.state;
      let items = {};
      build.tasks.map(task => {
        items = {
          ...items,
          [task.id]: task.id,
        };
      });
      this.setState({ isAllChecked: !value, selectedTasks: items });
    }else {
      this.setState({ isAllChecked: !value, selectedTasks: {} });
    }
  }

  checkToggled(id){
    const { selectedTasks } = this.state;
    let updatedTasks = { ...selectedTasks };
    if(selectedTasks[id]){
      delete updatedTasks[id];
    }else{
      updatedTasks = { ...updatedTasks, [id]: id };
    }
    this.setState({ selectedTasks: updatedTasks });
  }

  createStepsForDisplay() {
    const { build, selectedTasks } = this.state;

    if (typeof build.tasks[0] == 'number') {
      return <WaitSpinner />;
    }
    const tasks = build.tasks.map((task, index) => {
      let className = 'task-item';
      if (index == 0) {
        className += ' task-item--first';
      }
      const src = this.getIconForCSType(task);
      return (
        <li className={className} key={index}>
          <div>
          <CheckBox checked={selectedTasks[task.id]} toggleCheckBox={() => {this.checkToggled(task.id);}}/>
          </div>
          <p>{task.name.toUpperCase()}</p>
          <img src={src} alt={task.name}/>
        </li>
      );
    });

    return (
      <ul className='task-list'>
         <div className='task-header'>
          <div><CheckBox checked={this.state.isAllChecked} toggleCheckBox={this.toggleAll}/></div>
          <p className='sub-header'>{this.state.isAllChecked ? 'Deselect All' : 'Select All'}</p>
          </div>
        {tasks}
      </ul>
    );
  }

  render() {
    const { buildName, build } = this.state;
    const cancelIcon = ImageTools.getCancelIcon('white');

    return (
      <article 
        className={'copy-build-popout'}
        ref={el => this.copyBuildPopout = el}
      >
        <header className='copy-build-popout__header'>
          COPY BUILD
          <img 
            src={cancelIcon} 
            alt="cancel"
            className='close-button' 
            onClick={this.collapsePopup}
          />
        </header>
        <section className='copy-build-popout__container'>
          <div className='build-info'>
            <p className='build-info__text'>BUILD NAME</p>
            <Input className='build-info__input' 
              name='buildName'
              value={buildName}
              onChange={this.changeBuildInfo}
            />
          </div>
          {
            build.tasks.length > 0 &&
            <div className='task-info'>
              <p className='task-info__text'>Tasks</p>
              {this.createStepsForDisplay()}
            </div>
          }
        </section>
        <div className='copy-build-popout__button-container'>
          <button className='copy-button' onClick={this.collapsePopup}>
            CANCEL
          </button>
          <button 
            className={'copy-button copy-button__copy' + (buildName ? '-active' : '')}
            onClick={buildName && this.handleBuildCopy}
          >
            COPY
          </button>
        </div>
      </article>
    );
  }

}

export default CopyBuildPopout;



// WEBPACK FOOTER //
// ./src/components/CopyBuildPopout/index.js